import { getUnixTime } from 'date-fns';
import { AuditsTimePeriod, IAuditMetadata } from 'types/audits';

// Maximum results that audits api may return
// Implemented as a function so it could be overridden in test
export const maxAuditsSearch = (): number => 10000;

export const AUDITS_METADATA: Record<string, IAuditMetadata> = {
	// Users
	UserCreated: {
		message: 'audit.user.created',
		type: 'info'
	},
	UserDeleted: {
		message: 'audit.user.deleted',
		type: 'info'
	},
	UserModified: {
		message: 'audit.user.modified',
		type: 'info'
	},
	UsersModified: {
		message: 'audit.users.modified',
		type: 'info'
	},
	UsersDeleted: {
		message: 'audit.users.deleted',
		type: 'info'
	},
	// Access Keys
	AccessKeyCreated: {
		message: 'audit.accessKey.created',
		type: 'info'
	},
	AccessKeyDeleted: {
		message: 'audit.accessKey.deleted',
		type: 'info'
	},
	AccessKeyModified: {
		message: 'audit.accessKey.modified',
		type: 'info'
	},
	AccessKeysModified: {
		message: 'audit.accessKeys.modified',
		type: 'info'
	},
	AccessKeysDeleted: {
		message: 'audit.accessKeys.modified',
		type: 'info'
	},
	// Login
	LoginSucceed: {
		message: 'audit.login.succeed',
		type: 'info'
	},
	LoginFailed: {
		message: 'audit.login.failed',
		type: 'warn'
	},
	LoginExceedMaxAttempts: {
		message: 'audit.login.maxAttempts',
		type: 'warn'
	},
	UserRefresh: {
		message: 'audit.login.userRefresh',
		type: 'info'
	},
	// Projects
	ProjectDeleted: {
		message: 'audit.project.deleted',
		type: 'warn'
	},
	// Permissions
	PermissionCreated: {
		message: 'audit.permission.created',
		type: 'info'
	},
	PermissionUpdated: {
		message: 'audit.permission.modified',
		type: 'warn'
	},
	PermissionsDeleted: {
		message: 'audit.permission.deleted',
		type: 'warn'
	},
	// Roles
	RoleCreated: {
		message: 'audit.role.created',
		type: 'info'
	},
	RoleUpdated: {
		message: 'audit.role.modified',
		type: 'warn'
	},
	RolesDeleted: {
		message: 'audit.role.deleted',
		type: 'warn'
	},
	UsersRolesAssociationsModified: {
		message: 'audit.users.roles.modified',
		type: 'info'
	},
	// Project settings
	ProjectSettings: {
		message: 'audit.settings.ProjectSettings',
		type: 'info'
	},
	TenantSettings: {
		message: 'audit.settings.TenantSettings',
		type: 'info'
	},
	MagicLinkSettings: {
		message: 'audit.settings.MagicLinkSettings',
		type: 'info'
	},
	EnchantedLinkSettings: {
		message: 'audit.settings.EnchantedLinkSettings',
		type: 'info'
	},
	OTPSettings: {
		message: 'audit.settings.OTPSettings',
		type: 'info'
	},
	SAMLSettings: {
		message: 'audit.settings.SAMLSettings',
		type: 'info'
	},
	OAUTHSettings: {
		message: 'audit.settings.OAUTHSettings',
		type: 'info'
	},
	WebauthnSettings: {
		message: 'audit.settings.WebauthnSettings',
		type: 'info'
	},
	TOTPSettings: {
		message: 'audit.settings.TOTPSettings',
		type: 'info'
	},
	MessageProviderSettings: {
		message: 'audit.settings.MessageProviderSettings',
		type: 'info'
	},
	SamlCerts: {
		message: 'audit.settings.SamlCerts',
		type: 'info'
	},
	PasswordSettings: {
		message: 'audit.settings.PasswordSettings',
		type: 'info'
	}
};

export const auditTimePeriodToUnix = (timePeriod: AuditsTimePeriod) => {
	const today = new Date();
	let fromDate: number;
	switch (timePeriod) {
		case AuditsTimePeriod.Minutes15:
			fromDate = today.setMinutes(today.getMinutes() - 15);
			break;
		case AuditsTimePeriod.Hour:
			fromDate = today.setHours(today.getHours() - 1);
			break;
		case AuditsTimePeriod.Hour6:
			fromDate = today.setHours(today.getHours() - 6);
			break;
		case AuditsTimePeriod.Day:
			fromDate = today.setDate(today.getDate() - 1);
			break;
		case AuditsTimePeriod.Day3:
			fromDate = today.setDate(today.getDate() - 3);
			break;
		case AuditsTimePeriod.Week:
			fromDate = today.setDate(today.getDate() - 7);
			break;
		case AuditsTimePeriod.Week2:
			fromDate = today.setDate(today.getDate() - 14);
			break;
		default:
			// one month
			fromDate = today.setMonth(today.getMonth() - 1);
	}
	return getUnixTime(fromDate);
};

export const DefaultExcludedActions = ['UserRefresh'];
